import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TGpsrStore,
	TGetProductTypeResponsePayload,
	TSkuRequest,
	TSkuResponsePayload,
} from './types';

// ==========================================:
const getGpsrState = (state: TStoreState): TGpsrStore => state.gpsr;
export const getGpsr = createSelector([getGpsrState], (gpsr: TGpsrStore) => gpsr);

// ====================================================:

export const getProductType = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGetProductTypeResponsePayload => gpsr.productType,
);

// ====================================================:

export const getProductTypeIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.productTypeLoading,
);

// ====================================================:

export const getProductTypeError = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): string => gpsr.productTypeError,
);

// ====================================================:

export const getSku = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TSkuResponsePayload => gpsr.sku,
);

// ====================================================:

export const getSkuIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.skuLoading,
);

// ====================================================:

export const getSkuError = createSelector([getGpsr], (gpsr: TGpsrStore): string => gpsr.skuError);
